const qcChecklistLabels = {
  qualityChecked: 'Material Quality Checked',
  qtyVerified: 'Quantity Verified vs BOM',
  properPacking: 'Proper Packing & Wrapping',
  laserMarking: 'Laser Marking Verified',
  stickersDone: 'Stickers Applied',
  docsHanded: 'Documents Handed to Driver',
  safetyTag: 'Safety Tags Attached',
  informedHO: 'Informed HO/Sales'
};

export const deliveredReportColumns = [
  { header: 'Timestamp', value: ({ dispatch }) => dispatch.updatedAt },
  { header: 'Dispatch Date', value: ({ dispatch }) => dispatch.dispatchDate },
  { header: 'Serial No.- MOC', value: ({ dispatch }) => dispatch.mocNo },
  { header: 'Serial No. - Delivery Challan', value: ({ dispatch }) => dispatch.challanNo },
  { header: 'Organization', value: ({ dispatch }) => dispatch.firmId },
  { header: 'Warehouse', value: ({ dispatch }) => dispatch.warehouse },
  { header: 'Order Type', value: ({ dispatch }) => dispatch.typeOfMOC },
  { header: 'Aluminium Weight (in kgs)', value: ({ dispatch }) => dispatch.aluminiumWeight },
  { header: 'Total Weight (in kgs)', value: ({ dispatch }) => dispatch.totalWeight },
  { header: 'Delivered Meter', value: ({ dispatch }) => dispatch.totalMeter },
  { header: 'Total Meter', value: ({ order }) => order?.totalMeter ?? order?.totalMeterNumber },
  { header: 'Customer Name', value: ({ dispatch }) => dispatch.customerName },
  { header: 'Project Name', value: ({ order }) => order?.projectName },
  { header: 'Email - Customer Office', value: ({ dispatch }) => dispatch.billToEmail },
  { header: 'Email - Project Office', value: ({ dispatch }) => dispatch.shipToEmail },
  { header: 'Mobile Number - Project', value: ({ dispatch }) => dispatch.shippingPersonPhone },
  { header: 'Mobile Number - Office', value: ({ order }) => order?.shippingAddress?.phone },
  { header: 'Vehicle No.', value: ({ dispatch }) => dispatch.vehicleNumber },
  { header: 'Vehicle Type', value: ({ dispatch }) => dispatch.vehicleType },
  { header: 'In Time', value: ({ dispatch }) => dispatch.vehicleInTime },
  { header: 'Out Time', value: ({ dispatch }) => dispatch.vehicleOutTime },
  { header: 'Driver Name', value: ({ dispatch }) => dispatch.driverName },
  { header: 'Driver Contact', value: ({ dispatch }) => dispatch.driverContact },
  { header: 'Driver Documents', value: ({ dispatch }) => dispatch.deliveryChallanUrl },
  { header: 'Transporter Type', value: ({ dispatch }) => dispatch.deliveryMode },
  { header: 'Vehicle (Photo) Proof', value: ({ dispatch }) => dispatch.vehicleProofUrl },
  { header: 'DC Upload', value: ({ dispatch }) => dispatch.deliveryChallanUrl },
  { header: 'IMAGE - BOM / MOC (Filled & Signed)', value: ({ dispatch }) => dispatch.bomSignedUrl },
  { header: 'Dispatch Checklist', value: ({ dispatch }) => formatQcChecklist(dispatch.qcChecklist) },
  { header: 'Verified By', value: ({ dispatch }) => dispatch.qcVerifiedBy },
  { header: 'Logistic details', value: ({ order }) => order?.logisticsDetails },
  { header: 'Claimed Transport Charges', value: ({ order }) => order?.claimedChargesAsPerPoOrder },
  { header: 'Actual Transport Charge', value: ({ dispatch }) => dispatch.transportCharges ?? dispatch.deliveryDetails?.transportCharges },
  { header: 'Transporter', value: ({ dispatch }) => dispatch.dispatchedThrough }
];

export const formatQcChecklist = (qcChecklist) => {
  if (!qcChecklist || typeof qcChecklist !== 'object') return '';

  return Object.entries(qcChecklist)
    .filter(([, checked]) => Boolean(checked))
    .map(([key]) => qcChecklistLabels[key] || key)
    .join(', ');
};

export const normalizeCsvValue = (value) => {
  if (value === undefined || value === null) return '';
  if (typeof value.toDate === 'function') return value.toDate().toISOString();
  if (value instanceof Date) return value.toISOString();
  if (Array.isArray(value)) return value.join(', ');
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

export const escapeCsvCell = (value) => {
  const text = normalizeCsvValue(value);
  if (/[",\r\n]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
};

const resolveOrder = (dispatch, ordersById = {}) => {
  if (!dispatch?.orderId) return null;
  if (ordersById instanceof Map) return ordersById.get(dispatch.orderId) || null;
  return ordersById[dispatch.orderId] || null;
};

export const buildDeliveredReportCsv = ({ deliveries = [], ordersById = {} }) => {
  const headers = deliveredReportColumns.map((column) => column.header);
  const lines = [
    headers.map(escapeCsvCell).join(','),
    ...deliveries.map((dispatch) => {
      const order = resolveOrder(dispatch, ordersById);
      return deliveredReportColumns
        .map((column) => escapeCsvCell(column.value({ dispatch, order })))
        .join(',');
    })
  ];

  return `${lines.join('\n')}\n`;
};

export const getDeliveredReportFilename = (date = new Date()) => {
  const yyyyMmDd = date.toISOString().slice(0, 10);
  return `delivered-dispatches-report-${yyyyMmDd}.csv`;
};

export const downloadDeliveredReportCsv = ({
  deliveries = [],
  ordersById = {},
  filename = getDeliveredReportFilename()
}) => {
  const csv = buildDeliveredReportCsv({ deliveries, ordersById });
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
};
